module.exports = __webpack_public_path__ + "static/media/sourcesanspro-regular-webfont.d67b548b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-regular-webfont.woff2
// module id = 497
// module chunks = 0